let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hMfET")).then(() => parcelRequire('es9Pj'));